import type { FC } from "react";

import type { Finding } from "../model/Finding";
import type { Fix } from "../model/Fix";
import { FIX_TIPS, METRIC_TIPS } from "../model/FIX_TIPS";
import { fixRenderers } from "./fixRenderers";
import { FixTip } from "./FixTip";

type FindingFixesProps = {
  finding: Finding;
  // Без общего совета — только советы по данным (в карточках убийц и врагов).
  dataOnly?: boolean;
  className?: string;
};

// «Как исправить» у находки: общий совет по коду (метрике) и советы по данным из `fixes`.
// Сильным сторонам советы не нужны; советовать нечего — блока нет.
export const FindingFixes = ({ finding, dataOnly = false, className }: FindingFixesProps) => {
  if (finding.severity === "good") {
    return null;
  }
  const tip = dataOnly
    ? undefined
    : finding.code === "metric"
      ? METRIC_TIPS[finding.params.metric]
      : FIX_TIPS[finding.code];
  if (tip === undefined && finding.fixes.length === 0) {
    return null;
  }
  return (
    <div className={className ?? "mt-1.5 flex flex-col gap-1 border-t border-border pt-2"}>
      {tip !== undefined && <FixTip tip={tip} />}
      {finding.fixes.map((fix, index) => {
        const Renderer = fixRenderers[fix.code] as FC<{ fix: Fix }>;
        // Советы находки не меняются — индекс как ключ безопасен.
        return <Renderer key={index} fix={fix} />;
      })}
    </div>
  );
};
